export default {"src":"/_next/static/media/fancy.36b7e5e1.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};